import { PredicateTable } from '../plugin';

// TODO: units-metric?

export const I18N_PREDICATES: PredicateTable = {};
